module.exports = __webpack_public_path__ + "static/media/transparency-image5.7ef79da5.jpg";